import { $el, $list, whenDefined } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'
import { FloatElement } from '../float-element'

const INPUT_SELECTOR = `[data-localization-input]`
const FORM_SELECTOR = 'form'
const SEARCH_FIELD_SELECTOR = '[data-localization-search-field]'
const COUNTRY_SELECTOR = 'data-country'
const RESET_BTN_SELECTOR = `[data-search-field-reset-button]`

export class LocalizationSelector extends BaseComponent {
  labels: HTMLButtonElement[]
  resetButton: HTMLButtonElement

  mountComponent(): void {
    this.addListener(this, 'click', this.handleClick)

    const searchField = $el(SEARCH_FIELD_SELECTOR, this)

    if (searchField) {
      this.addListener(searchField, 'input', this.handleSearchInput)
      this.labels = $list(`[${COUNTRY_SELECTOR}]`, this)

      this.resetButton = $el(RESET_BTN_SELECTOR, this)
      this.addListener(this.resetButton, 'click', this.handleResetButtonClick)
    }
  }

  handleSearchInput = ({ target }) => {
    this.labels.forEach(label => {
      label.classList.toggle(
        'hidden',
        !label
          .getAttribute(COUNTRY_SELECTOR)
          .toLowerCase()
          .startsWith(target.value.toLowerCase()),
      )
    })

    this.resetButton.classList.toggle('hidden', !target.value.length)
  }

  handleResetButtonClick = () => {
    const input: HTMLInputElement = $el(SEARCH_FIELD_SELECTOR, this)

    input.value = ''
    input.dispatchEvent(new Event('input', { bubbles: true }))
    input.focus()
  }

  handleClick = (event: MouseEvent): void => {
    event.preventDefault()

    const target = event.target as HTMLElement
    const item = target.closest(`[data-localization-item]`) as HTMLElement

    if (item) {
      const input: HTMLInputElement = $el(INPUT_SELECTOR, this)
      const form: HTMLFormElement = $el(FORM_SELECTOR, this)

      if (!input || !form || !item.dataset.value) {
        return
      }

      input.value = item.dataset.value
      form.submit()

      const floatElement: FloatElement = this.closest('float-element')
      floatElement.hide()
    }
  }
}
